import React, { forwardRef, Ref } from 'react';
import styled from "styled-components";
import IComponentProps from "interfaces/IComponentProps";

const Video = styled.video`
  transform:rotateY(180deg);
`;

export default forwardRef((props:IComponentProps, ref:Ref<HTMLVideoElement>) => <Video ref={ref} autoPlay muted {...props}/>);